<template>
  <div>
    <!-- 客户下单商品属性 -->
    <div style="background: #f8f8f8; padding: 16px">
      <ol style="
            display: flex;
            height: 40px;
            background: #edeff4;
            border-radius: 4px 4px 0px 0px;
            justify-content: center;
            align-items: center;
          ">
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          {{ $t("message.customerOrdersCommodityAttributes") }}
        </li>
        <!-- 客户 -->
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          {{ $t("message.user") }}
        </li>
        <!-- 客户商品备注 -->
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          {{ $t("message.customerProductRemarks") }}
        </li>
        <!-- 业务回复 -->
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          {{ $t("message.businessReply") }}
        </li>
      </ol>
      <ul style="display: flex; padding: 10px 0">
        <!-- 客户下单商品属性 -->
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          <div class="customerOrdersCommodityAttributes">
            <el-tooltip placement="bottom">
              <div slot="content">
                <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                  style="margin-bottom: 5px">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
              <div :class="{ orderEdit: item.client_modify_field.indexOf('detail') != -1 }">
                <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
            </el-tooltip>
            <i class="el-icon-edit-outline" @click="attributeEdit" v-if="isAuth(492)">
            </i>
          </div>
        </li>
        <!-- 客户 -->
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          <div class="template">
            <!-- 数量 -->
            <p :class="{ orderEdit: item.client_modify_field.indexOf('detail') != -1 }">
              {{ $t("message.number") }}:{{ item.num }}
            </p>
            <!-- 单价 -->
            <p>
              {{ $t("message.price") }}:{{ item.price }}
            </p>
          </div>
        </li>
        <!-- 客户商品备注 -->
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          <div class="text">{{ item.client_remark }}</div>
        </li>
        <!-- 业务回复 -->
        <li style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
          {{ item.y_reply }}
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
import attribute from "./attribute";
export default {
  components: {
    attribute
  },
  props: {
    item: { type: Object },
    index: { type: Number },
  },
  data() {
    return {

    };
  },
  methods: {
    //业务修改属性
    attributeEdit() {
      this.$parent.$parent.attributeEdit(this.item, this.index, 'user')


      this.$forceUpdate()

    },

  },
};
</script>
<style lang='scss' scoped>
.orderEdit {
  background-color: #B4272D;
  color: #fff;


}

.customerOrdersCommodityAttributes {
  position: relative;
  width: 100%;
  display: flex;

  .row {}
}

.el-icon-edit-outline {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  color: #c60524;
  font-size: 18px;
}
</style>